/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manager_Question_OptionalInputs */



/**
* | output |
* | --- |
* | "Optional" |
*
* @param {Manager_Question_OptionalInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const manager_question_optional = /** @type {((inputs?: Manager_Question_OptionalInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manager_Question_OptionalInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Optioneel")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Facultatif")
	return /** @type {LocalizedString} */ ("Optional")
});